import { render, staticRenderFns } from "./ImportStudentCsvDetail.vue?vue&type=template&id=5030cc79&"
import script from "./ImportStudentCsvDetail.vue?vue&type=script&lang=ts&"
export * from "./ImportStudentCsvDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports